import { action as mobxAction, makeAutoObservable, toJS, observable, computed } from 'mobx'
import { FullS3DomainOptions, GlobalConfig, IMenu, WorksStoreProps } from './types'
import globalData from './globalData'
import globalEnumInside from './globalEnumInside'
import Api from '@/server'
import { get, getMerchantCodeStr, set } from '@/utils/tools'
import * as 枚举值 from '@/types/ConstantRecord'
import pageControl from '@/utils/Cache/pageControl'
import { replaceDoubleSlashes, webpSupport } from './tools'
import { EventEmitter } from '@/utils/event'
import { ENV_NAME } from '@/env'
import { refreshAllEnum } from '@/utils'

export class WorksStore {
    constructor(props: WorksStoreProps) {
        makeAutoObservable(this)
    }

    @observable menuLevelOne: string = ''
    @observable defaultCurrency: string = 'CNY'

    @observable supportWebp = webpSupport()

    @observable token: string = ''

    @observable merchantCode: string = ''

    @observable merchantList: Array<any> = []
    @observable navTabs: Array<any> = []

    @observable currentMerchantInfo: any = {}

    @observable isOrganizationAdmin: boolean = false

    @observable isPlatformAdmin: boolean = false

    @observable isLogin: boolean = false

    @observable tagWidth: number = 600

    @observable tagWidthHalf: number = 300

    @observable userInfo: Record<string, any> = {}

    // 控制页面开发用数据显示隐藏的值
    @observable _showField: boolean = false
    // 用来判断是否拉取用户信息已完成
    @observable _isInitUserInfoFinish: boolean = false

    @observable menus: Array<IMenu> = []

    @observable globalEnum: Record<string, any> = globalData
    @observable globalEnumInside: Record<string, any> = globalEnumInside
    @observable globalEnumKV: Record<string, any> = {}

    @observable isAllPerm = false

    @observable globalConfig: GlobalConfig = {
        // imageDomain: "https://ccff-img.s3.ap-east-1.amazonaws.com/",
        imageDomain: 'https://cpimg-7972.s3.ap-east-1.amazonaws.com/',
        fileDomain: 'https://ccff-excel-upload.s3.ap-east-1.amazonaws.com/',
    }

    @observable notificationCount = 0

    /** 入款 */
    @observable depositNotification = 0
    /** 提现 */
    @observable withdrawNotification = 0
    /** 在线会员 */
    @observable onlineNotification = 0
    /** 在线会员 */
    @observable platformBroadcastsRes: any = []

    /** 用户的权限 */
    @computed get permMap() {
        const userInfo = this.userInfo
        const permIds = get(userInfo, 'permCodes', [])
        const result = permIds.reduce((acc: Record<string, boolean>, cur: string) => {
            acc[cur] = true
            return acc
        }, {})
        return result
    }

    @mobxAction
    switchField = () => {
        this._showField = !this._showField
    }
    @mobxAction
    setNavTabs = (navTabs: Array<any>) => {
        this.navTabs = navTabs
    }

    @mobxAction
    setInitUserInfoFinish = (result: boolean) => {
        this._isInitUserInfoFinish = result
    }

    @mobxAction
    init = (arr: Array<IMenu>) => {
        this.menus = arr
    }

    @mobxAction
    initStore = () => {
        pageControl.destory()
        const merchantCodeStr = getMerchantCodeStr()
        this.token = localStorage.getItem('token') || ''
        this.merchantCode = (localStorage.getItem('merchantCode') || merchantCodeStr || '').toUpperCase()
        if (this.merchantCode) {
            localStorage.setItem("merchantCode", this.merchantCode)
        }
        this.isLogin = !!this.token
        const loginAndRedirect = async () => {
            try {
                const data: any = await this.getUserInfo()
                if (!data) {
                    window.location.hash = '#/'
                    return
                }
                if (localStorage.getItem('isSwitchableUser') === 'true') {
                    workStore.setMultiWebsiteInfo({
                        isOrganizationAdmin: true,
                    })
                }
                workStore.setMultiWebsiteInfo({
                    merchantList: get(data, 'merchantList', []),
                })
                if (this.merchantCode) {
                    EventEmitter.emit('loopGetNotification', {})
                }
                workStore.refreshMerchantInfo()
                const nowHash = window.location.hash?.replace('#', '')
            } catch (e) {
                window.location.hash = '#/'
            }
        }
        if (this.isLogin) {
            loginAndRedirect()
        } else {
            window.location.hash = '#/'
        }
        setTimeout(() => { }, 3000)
    }
    @mobxAction
    refreshMerchantList = async () => {
        const data: any = await this.getUserInfo()
        workStore.setMultiWebsiteInfo({
            merchantList: get(data, 'merchantList', []),
        })
    }
    @mobxAction
    refreshMerchantInfo = async () => {
        if (this.merchantCode) {
        }
    }

    @mobxAction
    login = (token: string) => {
        this.setToken(token)
        this.isLogin = true
    }

    @mobxAction
    logout = async () => {
        try {
            await Api.postAuth('/auth/logout', {})
            EventEmitter.emit('clearItemsWhenLogout', {})
            EventEmitter.emit('stopLoopGetNotification', {})
            this.token = ''
            localStorage.removeItem('token')
            localStorage.removeItem('menuLevelOne')
            this.isLogin = false
            this._isInitUserInfoFinish = false
            this.clearMultiWebsiteInfo()
            // window.location.reload()
        } catch (e) { }
    }

    @mobxAction
    setNotificationCount = (count: number) => {
        this.notificationCount = count
    }
    @mobxAction
    setDepositNotification = (count: number) => {
        this.depositNotification = count
    }
    @mobxAction
    setWithdrawNotification = (count: number) => {
        this.withdrawNotification = count
    }
    @mobxAction
    setOnlineNotification = (count: number) => {
        this.onlineNotification = count
    }

    @mobxAction
    setMultiWebsiteInfo = (data: {
        merchantCode?: string
        merchantList?: Array<any>
        currentMerchantInfo?: any
        isOrganizationAdmin?: boolean
        isPlatformAdmin?: boolean
    }) => {
        if (data.merchantCode) {
            this.merchantCode = data.merchantCode
        }
        if (data.merchantList) {
            this.merchantList = data.merchantList
        }
        if (data.currentMerchantInfo) {
            this.currentMerchantInfo = data.currentMerchantInfo
        }
        if (data.isOrganizationAdmin) {
            this.isOrganizationAdmin = data.isOrganizationAdmin
        }
        if (data.isPlatformAdmin) {
            this.isPlatformAdmin = data.isPlatformAdmin
        }
    }

    @mobxAction
    clearMultiWebsiteInfo = () => {
        localStorage.removeItem('merchantCode')
        localStorage.removeItem('isSwitchableUser')
        this.merchantCode = ''
        this.merchantList = []
    }

    @mobxAction
    setImageDomain = (url: string) => {
        this.globalConfig.imageDomain = url
    }

    @mobxAction
    setGlobalEnum = (data: any) => {
        const 内部枚举值 = {} as Record<any, any>
        for (let [key, items] of Object.entries(枚举值)) {
            const map = [] as Array<any>
            for (let [k, v] of Object.entries(items)) {
                if (!Object.keys(items).includes(v)) {
                    map.push({ label: k, value: String(v) })
                }
            }
            内部枚举值[key] = map
        }
        data['内部枚举值'] = 内部枚举值
        this.globalEnum = data
    }

    @mobxAction
    setMenuLevelOne = (d: any) => {
        const companyMenu = ['platform-management']
        const wasInCompany = companyMenu.includes(this.menuLevelOne)
        const isInCompany = companyMenu.includes(d)

        if (wasInCompany !== isInCompany) {
            refreshAllEnum()
        }


        this.menuLevelOne = d
    }

    @mobxAction
    setGlobalEnumKV = (data: any) => {
        const 内部枚举值 = {} as Record<any, any>
        for (let [key, items] of Object.entries(枚举值)) {
            const map = {} as Record<any, any>
            for (let [k, v] of Object.entries(items)) {
                if (!Object.keys(items).includes(v)) {
                    map[String(v)] = k
                }
            }
            内部枚举值[key] = map
        }
        data['内部枚举值'] = 内部枚举值
        this.globalEnumKV = data
    }

    getImageUrl = (url: string, options: FullS3DomainOptions = {}) => {
        const { autoTransform = false, isLocal = false } = options
        if (url === '') {
            return url
        }
        if (url.includes('http')) {
            return url
        }
        if (url.includes('data:image')) {
            return url
        }
        if (autoTransform && this.supportWebp) {
            url = url.replace(/\.jpg|\.png|\.jpeg/, '.webp')
        }
        const fullUrl = `/${url}`.replace('//', '/')
        if (isLocal) {
            return `./images${fullUrl}`
        }
        let s3Domain = this.globalConfig.imageDomain
        const apiEnv = process.env.REACT_APP_ENV as ENV_NAME || ENV_NAME.DEV
        if (apiEnv === 'PROD') {
            s3Domain = 'https://cpimg-3486.s3.ap-east-1.amazonaws.com'
        }
        const result = replaceDoubleSlashes(`${s3Domain}${fullUrl}`)
        return result
    }

    getFileUrl = (url: string) => {
        return `${this.globalConfig.fileDomain}${String(url).replace(/^\//, '')}`
    }

    checkPerm = (permKey: string) => {
        const userInfo = this.userInfo
        const permIds = get(userInfo, 'permCodes', []) as Array<string>
        return permIds.includes(permKey)
    }

    @mobxAction
    setToken = (token: string) => {
        this.token = token
        localStorage.setItem('token', token)
    }

    @mobxAction
    setUserInfo = (userInfo: any) => {
        this.userInfo = userInfo
    }

    @mobxAction
    getUserInfo = async () => {
        const userInfo = await Api.post(`/userManage/userInfo`, {})
        if (userInfo) {
            this.setUserInfo(userInfo)
            this._isInitUserInfoFinish = true
        } else {
            this._isInitUserInfoFinish = false
            // token过期
        }
        return userInfo
    }
}

export const workStore = new WorksStore({})
